export default __webpack_public_path__ + "static/media/arrow-right-up.fc0f52d5.svg";